export function getDevicePlatform() {
  const userAgent = navigator.userAgent || navigator.vendor;

  // Check for Android
  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // Check for iOS (iPhone, iPad, iPod)
  // Note: Newer iPads might report as 'MacIntel', so we check for touch points too
  if (
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  ) {
    return 'iOS';
  }

  return 'Desktop/Other';
}
